import './notificaciones.css';
import { useState, useEffect } from "react";
import { useNavigate} from 'react-router-dom';
function Notificaciones({abrir, Notsobtenidas, abcer}) {

const navigate = useNavigate();
const [notopen, setnotopen] = useState();
const [notsobtenidas, setnotsobtenidas] = useState([]); 

async function getDayIndex(targetDate) {
    const localDateString = new Date();

    // Reconstruct the output in the desired format:
    const today = new Date()
    
    const notdate = new Date(targetDate)

    // Aseguramos que las horas no afecten la diferencia de días
    console.log('usual today:', localDateString);
    console.log('not date:', notdate);

    const timemili = notdate.getTime() - today.getTime();

    // Calculamos la diferencia en milisegundos y convertimos a días
    const differenceInDays = Math.ceil((timemili) / (1000 * 60 * 60 * 24));
    console.log(differenceInDays);

      // Convert the string to a Date object
  
    const datatosend = {dia: differenceInDays, id: 150};
    if (differenceInDays >= 0 ){
        console.log(differenceInDays);
        navigate('/', {state: {from: 'notific', msg:datatosend}});
        abcer();
    }
}

const abrircerrar = () => {
    abcer();
}

useEffect(()=>{
    setnotopen(abrir);
    setnotsobtenidas(Notsobtenidas);
}, [abrir]);

    return(
        <>{notopen === false ? (<></>):(<div className='outnot' onClick={abrircerrar}>
            <div  className='notificaciones'>
                <div>
                    <ul>{notsobtenidas.length > 0 ? (<>
                        {notsobtenidas.map((not,i)=>(
                            <li className='linots' key={i} onClick={() => getDayIndex(not.dia)}> 
                            Nueva solicitud para el {((not.dia).split('-')[2]).split('T')[0]}/{(not.dia).split('-')[1]}/{(not.dia).split('-')[0]} a las {(not.hora).split(':')[0]}:00 <br/>
                            <p className='timestamp'>{not.timestamp2}</p>
                            </li>
                        ))}
                    </>):(<>
                        <li className='linots'>
                            No hay notificaciones.
                        </li>
                        </>)}
                        
                    </ul>
                </div>
            </div>
        </div>)}
        </>
    );
}
export default Notificaciones;